import React, { useEffect, useRef, useState } from 'react';
import { canUseDOM } from '../../../utils';
const InfiniteCarousel = _ref => {
  let {
    direction,
    images,
    rtl
  } = _ref;
  const trackRef = useRef(null);
  const positionRef = useRef(direction === 'left' ? 0 : -350); // using useRef here? to avoid unnecessary re-renders
  const animationFrameId = useRef(null); // need for correct work of rtl mode
  const speed = 1;
  const [itemWidth, setItemWidth] = useState(() => canUseDOM && window.matchMedia("(max-width: 992px)").matches ? 190 : 350); // 180 + 5 + 5 (margin) or width 340 + 5 + 5 (margin)

  const itemWidthRef = useRef(itemWidth);
  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.matchMedia("(max-width: 992px)").matches ? 190 : 350;
      setItemWidth(newWidth);
      itemWidthRef.current = newWidth;
    };
    if (canUseDOM) {
      window.addEventListener("resize", handleResize);
    }
    return () => {
      if (canUseDOM) {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);
  const animate = () => {
    const track = trackRef.current;
    if (!track) return;
    if (direction === "left") {
      positionRef.current -= speed;
    } else if (direction === "right") {
      positionRef.current += speed;
    }
    track.style.transform = `translateX(${positionRef.current}px)`;
    const items = track.children; // 'carousel-item'
    if (!items.length) return;
    const currentItemWidth = itemWidthRef.current;
    if (direction === "left" && Math.abs(positionRef.current) >= currentItemWidth) {
      track.appendChild(items[0]);
      positionRef.current += currentItemWidth;
      track.style.transform = `translateX(${positionRef.current}px)`;
    } else if (direction === "right" && positionRef.current >= 0) {
      const lastItem = items[items.length - 1];
      track.insertBefore(lastItem, items[0]);
      positionRef.current -= currentItemWidth;
      track.style.transform = `translateX(${positionRef.current}px)`;
    }
    animationFrameId.current = requestAnimationFrame(animate);
  };
  useEffect(() => {
    if (animationFrameId.current) cancelAnimationFrame(animationFrameId.current);
    animationFrameId.current = requestAnimationFrame(animate);
    return () => {
      if (animationFrameId.current) cancelAnimationFrame(animationFrameId.current);
    };
  }, [direction, rtl]);
  return /*#__PURE__*/React.createElement("div", {
    className: "carousel-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "carousel-track",
    ref: trackRef,
    style: {
      direction: rtl ? "ltr" : "ltr"
    }
  }, images.map((_ref2, index) => {
    let {
      image
    } = _ref2;
    return /*#__PURE__*/React.createElement("div", {
      className: "carousel-item",
      key: index
    }, /*#__PURE__*/React.createElement("img", {
      src: image.jss.value.src,
      alt: image.jss.value.alt
    }));
  })));
};
export default InfiniteCarousel;